<template>
  <section class="closefriend-hero h-100" >

    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>


    <influencer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></influencer-menu>
    <header-menu @slideMenu="slideBar()" :is-loading="isLoading"></header-menu>

    <div class="container mt-5">
        <div class="row">
          <div class="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-6 offset-xl-3">
            <div class="login-card">
              <global-message></global-message>
              <div class="login-body">
                <div class="custom-body mb-3">

                  <div class="d-flex justify-content-end mb-2">
                    <i class="fa fa-times text-white font-size-24 cursor-pointer" @click="$router.replace({name: 'BonusContentList'})"></i>
                  </div>

                </div>


                <div :status="uploadStatus" class="stella-upload-card text-center" :class="{'stella-upload-card-error': !!fileErrorMessage}" @click="$refs.file.click()">
                  <div class="img-wrapper-main">
                    <div class="upload-placeholder"></div>
                    <div data-upload class="font-grey font-size-16 font-weight-600">Upload Media</div>
                    <div data-uploading class="font-grey font-size-16">Uploading...</div>
                    <div data-uploaded class="font-grey font-size-16">File uploaded</div>
                    <div data-upload class="font-dark-grey font-size-13 mt-2">{{ supportedFormatsText }}</div>
                    <div data-upload class="font-dark-grey font-size-12 mt-1" style="opacity: 0.8;">{{ maxFileSizeText }} &bull; 4:5 ratio recommended</div>
                    <div data-uploading class="font-dark-grey font-size-14 mt-2">The photo will be displayed as 4:5 ratio</div>
                    <!-- <div data-uploaded class="font-dark-grey font-size-14 mt-2">happybirthdayjack.mov</div> -->
                    <input type="file" class="d-none" id="fileInput" :accept="allowedMediaAccept" ref="file" @change="loadFile($event)">
                  </div>
                </div>

                <!-- Validation and Error Banner -->
                <div v-if="fileErrorMessage" class="stella-upload-error-banner danger mt-3 p-3 d-flex align-items-center rounded-3"
                     style="background: rgba(255, 80, 56, 0.12); border: 1px solid rgba(255, 80, 56, 0.4); border-radius: 10px;">
                  <i class="fa fa-exclamation-triangle me-2 font-size-16" style="color: #FF5038;"></i>
                  <div class="text-start">
                    <div class="font-size-13 font-weight-600" style="color: #FF5038;">Unsupported File Format</div>
                    <div class="font-size-12 text-white-50 mt-1">{{ fileErrorMessage }}</div>
                  </div>
                </div>
                <div v-else-if="isSubmit && !isFileSelected" class="stella-upload-error-banner danger mt-3 p-3 d-flex align-items-center rounded-3"
                     style="background: rgba(255, 80, 56, 0.12); border: 1px solid rgba(255, 80, 56, 0.4); border-radius: 10px;">
                  <i class="fa fa-exclamation-circle me-2 font-size-16" style="color: #FF5038;"></i>
                  <span class="font-size-13 font-weight-500" style="color: #FF5038;">Please select a supported file before saving (JPG, PNG, GIF, WebP, MP4, MOV).</span>
                </div>

                <div class="upload-data mt-4" @click="$refs.file.click()">
                  <img v-show="!isVideo"
                       src="@/assets/images/loading.svg"
                       id="user_upload_image"
                       class="img-fluid">
                  <video v-show="isVideo"
                         controls oncontextmenu="return false;" controlsList="nodownload"
                         id="user_upload_video"
                         style="max-width: 100%;max-height: 400px;">
                  </video>
                  <div class="remove-img rounded-pill cursor-pointer" @click.stop="removeSelectedFile()">
                    <i class="fa fa-times text-white me-1 font-size-12"></i>
                    <span class="ms-1 font-family-poppins font-size-14 font-dark-grey">Remove</span>
                  </div>
                </div>

                <label for="description" class="font-grey">
                  <required-field v-if="isRequired('description')"/>
                </label>
                <div class="form-group">
                  <textarea
                         class="form-control"
                         placeholder="Description"
                         v-model="description"
                         style="background-color: #1a1a1a !important; color: #fff !important; border: 1px solid #333 !important;"></textarea>
                </div>

                <div class="form-group">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <label for="price_section" class="font-grey mb-0">
                      Content Price <required-field v-if="isPaid && isRequired('price')"/>
                    </label>
                    <div class="btn-group btn-group-sm" role="group" style="background-color: #1a1a1a; border-radius: 20px; padding: 2px;">
                      <button type="button" 
                              class="btn rounded-pill px-4" 
                              :class="!isPaid ? 'stella-btn gradient-a text-white font-weight-600' : 'text-muted'" 
                              style="border: none; box-shadow: none;"
                              @click="isPaid = false; price = null">Free</button>
                      <button type="button" 
                              class="btn rounded-pill px-4" 
                              :class="isPaid ? 'stella-btn gradient-a text-white font-weight-600' : 'text-muted'" 
                              style="border: none; box-shadow: none;"
                              @click="isPaid = true">Paid</button>
                    </div>
                  </div>
                  <div class="input-group" v-if="isPaid" style="max-width: 150px;">
                    <div class="input-group-prepend">
                      <span class="input-group-text" style="background-color: #333; color: #fff; border: 1px solid #333; border-right: none;">$</span>
                    </div>
                    <input type="number" min="0" maxlength="6"
                           :placeholder="pricePlaceHolder"
                           class="form-control"
                           id="price_section"
                           v-model="price"
                           oninput="if(this.value.length > 6) this.value = this.value.slice(0, 6);"
                           onkeypress="return event.keyCode === 8 || (event.charCode >= 48 && event.charCode <= 57 && event.target.value.length < 6)"
                           style="background-color: #1a1a1a !important; color: #fff !important; border: 1px solid #333 !important; border-left: none;">
                  </div>
                </div>
                <div class="form-group">
                  <div class="custom-control custom-checkbox dashboard-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           tabindex="3" name="pinned" v-model="pinned" id="pinned-id">
                    <label class="custom-control-label text-white" for="pinned-id" style="min-height: 20px;">Pin this post to top of your page?</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="custom-control custom-checkbox dashboard-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           name="pinned" v-model="notifySubscribers"
                           tabindex="3" id="notify-id">
                    <label class="custom-control-label text-white" for="notify-id" style="min-height: 20px;">Notify Subscribers?</label>
                  </div>
                </div>
              </div>
              <div class="mt-4 mb-2 d-flex justify-content-end">
                <button type="submit" @click="handleFileUpload()"
                        class="btn stella-btn gradient-a rounded-pill font-weight-500 px-5 py-2 w-auto">
                  <span class="text-white font-size-14 font-weight-600">Save</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    <model-progress ref="progress"
                    :upload-percentage="uploadPercentage"
                    :text="progressText"
                    @cancel="cancelUpload()"/>

  </section>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

import {httpMixin} from "@/mixin/http-mixin";
import {newSubscriptionMixin} from "@/mixin/new-subscription-mixin";
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import InfluencerMenu from "@/components/module/influencer/shared/InfluencerMenu";
import InfluencerHeader from "@/components/module/influencer/shared/InfluencerHeader";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import ModelProgress from "@/components/module/shared/ModelProgress";
import RequiredField from "@/components/module/shared/RequiredField";
import PwaActionBar from "@/components/module/influencer/shared/PwaActionBar";
import {required} from "vuelidate/lib/validators";
import {constructCustomerURL} from "@/common/baseURL-service";
import {SERVICE_CONTENT} from "@/properties/micro-service";
import axios from "axios";
import {ACCESS_TOKEN, BASE_URL} from "@/properties/close-friend";
import {getBaseURL, getToken} from "@/common/http-common";
import {tipMixin} from "../../../../mixin/customer-account/tipMixin";
import {
  ALLOWED_MEDIA_ACCEPT,
  isMediaFile,
  isVideoFile,
  MEDIA_RESTRICTION_ERROR_MESSAGE,
  SUPPORTED_FORMATS_TEXT,
  MAX_FILE_SIZE_TEXT
} from "@/common/media-utils";

export default {
  name: 'BonusContentAdd',
  title: 'Add bonus content',
  mixins: [httpMixin, newSubscriptionMixin, tipMixin],
  components: {
    HeaderMenu, InfluencerMenu, ModelProgress,
    InfluencerHeader, GlobalMessage, RequiredField, PwaActionBar
  },
  data() {
    return {
      user: {},
      description: null,
      price: null,
      pinned: false,
      showSlideBar: false,
      isSubmit: false,
      isVideo: false,
      isPaid: false,
      isFileSelected: true,
      fileErrorMessage: null,
      allowedMediaAccept: ALLOWED_MEDIA_ACCEPT,
      supportedFormatsText: SUPPORTED_FORMATS_TEXT,
      maxFileSizeText: MAX_FILE_SIZE_TEXT,

      uploadPercentage: 0,
      request: null,
      progressText: undefined,
      notifySubscribers: true,
      isUploading: false,
      uploadStatus: 'upload',
      imageUrl: null,
      videoUrl: null
    }
  },
  validations() {
    if (this.isPaid) {
      return {
        description: {required},
        price: {required}
      }
    } else {
      return {
        description: {required},
      }
    }
  },
  created() {
    this.user = typeof this.getUser === 'function' ? this.getUser() : (this.getUser || {});
  },
  computed: {
    copyLabel() {
      return this.copied ? 'Copied' : 'Copy';
    },
    pricePlaceHolder() {
      return this.isPaid ? 'Price' : 'Free for subscribers';
    }
  },
  methods: {
    ...mapGetters(['getUser']),
    ...mapActions(['setUser', 'setMessage', 'setWarning']),
    constructCustomerURL,
    cancelUpload() {
      if (this.request && this.request.cancel) {
        this.request.cancel();
      }
      this.isUploading = false;
      this.$refs.progress.hide();
    },
    handleFileUpload() {

      this.isSubmit = true;
      const file = this.$refs.file && this.$refs.file.files ? this.$refs.file.files[0] : null;
      this.isFileSelected = !!file && isMediaFile(file);
      this.$v.$touch();
      if (this.$v.$invalid || !file || !isMediaFile(file)) {
        if (file && !isMediaFile(file)) {
          this.fileErrorMessage = MEDIA_RESTRICTION_ERROR_MESSAGE;
        }
        return;
      }

      this.fileErrorMessage = null;
      this.isUploading = true;
      this.$refs.progress.show();
      let ext = file.name.split('.').pop();

      // Step 1: Get a presigned URL from the generic upload endpoint
      let presignedUrlEndpoint = `${SERVICE_CONTENT}/api/v1/upload/presigned-url?fileExtension=${ext}`;

      axios.post(presignedUrlEndpoint, {}, {
        baseURL: getBaseURL(),
        headers: {
          'Authorization': `Bearer ${getToken(ACCESS_TOKEN)}`,
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        let uploadUrl = response.data.uploadUrl;
        let s3Key = response.data.s3Key;
        let expectedContentType = response.data.contentType || file.type;
        
        const axiosSource = axios.CancelToken.source();
        this.request = {cancel: axiosSource.cancel, msg: "Loading..."};
        
        // Step 2: Upload the file directly to S3
        return axios.put(uploadUrl, file, {
          headers: {
            'Content-Type': expectedContentType
          },
          onUploadProgress: (progressEvent) => {
            this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
            if (this.uploadPercentage === 100) {
              this.progressText = 'Upload complete, please wait for sync up';
            }
          },
          cancelToken: axiosSource.token
        }).then(() => {
           // Step 3: Save content metadata with s3Key
           let saveUrl = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/content/s3`;
           return axios.post(saveUrl, {
             s3Key: s3Key,
             description: this.description,
             price: this.price ? this.price : '0',
             pinned: this.pinned,
             notifySubscribers: this.notifySubscribers
           }, {
             baseURL: getBaseURL(),
             headers: {
               'Authorization': `Bearer ${getToken(ACCESS_TOKEN)}`,
               'Content-Type': 'application/json',
               'base-url': BASE_URL
             }
           });
        });
      }).then(() => {
        this.isUploading = false;
        this.$refs.progress.hide();
        this.$router.replace({name: 'BonusContentList', params: {isSaved: true}});
      }).catch((e) => {
        this.isUploading = false;
        this.$refs.progress.hide();
        this.catchError(e, true);
        this.setWarning('UPLOAD.CANCELLED');
      });
    },
    isRequired(attrib) {
      return this.isSubmit && !this.$v[attrib].required;
    },
    toggle() {
      this.isPaid = !this.isPaid;
      this.price = !this.isPaid ? null : this.price;
    },
    removeSelectedFile() {
      this.isFileSelected = false;
      this.fileErrorMessage = null;
      this.uploadStatus = 'upload';
      this.isVideo = false;
      if (this.$refs.file) {
        this.$refs.file.value = "";
      }
      const img = document.getElementById('user_upload_image');
      if (img) img.src = "";
      const video = document.getElementById('user_upload_video');
      if (video) video.src = "";
    },
    loadFile() {
      const file = this.$refs.file && this.$refs.file.files ? this.$refs.file.files[0] : null;
      if (!file) {
        this.isFileSelected = false;
        this.fileErrorMessage = null;
        this.uploadStatus = 'upload';
        return;
      }
      if (!isMediaFile(file)) {
        this.isFileSelected = false;
        this.fileErrorMessage = MEDIA_RESTRICTION_ERROR_MESSAGE;
        if (this.$refs.file) {
          this.$refs.file.value = "";
        }
        this.uploadStatus = 'upload';
        this.isVideo = false;
        const img = document.getElementById('user_upload_image');
        if (img) img.src = "";
        const video = document.getElementById('user_upload_video');
        if (video) video.src = "";
        return;
      }

      this.fileErrorMessage = null;
      this.isFileSelected = true;
      this.uploadStatus = 'uploading';

      setTimeout(() => {
        this.uploadStatus = 'uploaded';

        if (isVideoFile(file)) {
          this.isVideo = true;
          const img = document.getElementById('user_upload_image');
          if (img) img.src = "";
          const video = document.getElementById('user_upload_video');
          if (video) video.src = URL.createObjectURL(file);
        } else {
          this.isVideo = false;
          const video = document.getElementById('user_upload_video');
          if (video) video.src = "";
          const img = document.getElementById('user_upload_image');
          if (img) img.src = URL.createObjectURL(file);
        }
        setTimeout(() => {
          this.uploadStatus = 'hide';
        }, 500);

      }, 500);
    },

    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    },
  }
}

</script>


